import React from 'react';
import styled, { css } from 'styled-components';
import { useQuery } from '@redux-requests/react';
import { SelectOption, IconLookup, Icon } from 'component-library-and-tools';

import { EXTRACT_TERMS_FROM_TEXT } from 'services/safelists/actions';
import SearchBar from 'shared/components/SearchBar';
import Select from 'shared/components/Select';
import Checkbox from 'shared/components/Checkbox';

import { SELECT_TYPE_OPTIONS } from '../../../constants';

import { ReviewAreaControlBarProps } from './types';

const StyledControlBarContainer = styled.div`
  display: flex;
  align-items: center;
`;

const commonControlStyles = css`
  height: 3.67rem;
  font-size: 1.167rem;

  &:not(:last-child) {
    margin-right: 1rem;
  }
`;

const StyledCheckbox = styled(Checkbox)`
  ${commonControlStyles}

  && {
    margin-right: 2rem;
  }
`;

const StyledSearchInput = styled(SearchBar)`
  ${commonControlStyles}
`;

const StyledSelect = styled(Select)`
  ${commonControlStyles}

  width: 12.5rem;
`;

const ReviewAreaControlBar = ({
  className,
  allSelected = false,
  onCheckDisabled = false,
  onSearch,
  onSelectType,
  onSelectAll,
  onAddNewTerm,
}: ReviewAreaControlBarProps) => {
  const { loading } = useQuery({ type: EXTRACT_TERMS_FROM_TEXT });

  const onSelectTypes = (selectedOptions: SelectOption[]) => {
    const selectedTypes = selectedOptions.map((selectedOption) => selectedOption.name);

    onSelectType(selectedTypes);
  };

  return (
    <StyledControlBarContainer className={className}>
      <StyledCheckbox
        isDisabled={onCheckDisabled || loading}
        isChecked={allSelected}
        onChange={onSelectAll}
      />
      <StyledSearchInput
        placeholder='Search items...'
        onSearch={onSearch}
      />
      <StyledSelect
        isMultiSelect
        placeholder='Select type'
        allSelectedLabel='Type: All'
        options={SELECT_TYPE_OPTIONS}
        onSelect={(selectedOptions) => onSelectTypes(selectedOptions as SelectOption[])}
      />
      <Icon fontSize={'2rem'} icon={IconLookup.PLUS_CIRCLE} onClick={onAddNewTerm} />
      {/* Commented until we got the data to support it. */}
      {/* <StyledSelect
        placeholder='Mark As'
        options={[]}
      /> */}
    </StyledControlBarContainer>
  );
};

export { ReviewAreaControlBar };
